<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tom Turner grew up in rural Ohio, leaving as a young man to attend West Point. After military service, he spent many years working in corporate America in senior management positions. He has been married for nearly 50 years, with three children and three grandchildren, and has lived in North Carolina for almost 40 years. He likes golf, writing, selling real estate, and date nights with his wife.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?d6f80d12